module.exports = require("./../../_gen/starling/text/TextFormat");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/text/TextFormat.js
// module id = 230
// module chunks = 0